export const setSettingsList = (state, reqResponse) => {
    state.settingsList = reqResponse.data;
    state.loadingSettings = false;
};
